<div class="flex w-full flex-auto flex-col">

    <div
        class="bg-card relative flex w-full flex-col border border-1 shadow
               dark:border-b dark:bg-transparent dark:shadow-none"
    >
        <!-- ================= HEADER ================= -->
        <div class="flex h-14 items-center justify-between px-6">
            <div class="flex items-center">
                <!-- <mat-icon class="mr-3 text-primary">devices</mat-icon> -->
                <h2 class="text-lg font-semibold tracking-tight">
                    Device Registration
                </h2>
            </div>

            <button
                *ngIf="userRole === 'VendorAdmin'"
                (click)="registerDevice()"
                class="inline-flex items-center gap-2
                       rounded-lg bg-primary px-5 py-2
                       text-sm font-semibold text-white
                       shadow transition hover:bg-primary-700"
            >
                <mat-icon>add</mat-icon>
                Register Device
            </button>
        </div>


        <!-- ================= CONTENT ================= -->
        <div class="flex flex-col gap-6 px-6 py-6 pt-0">

            <!-- ================= TABLE ================= -->
            <div class="overflow-x-auto rounded-xl border border-divider bg-hover">
                <table class="w-full text-sm">

                    <!-- HEADER -->
                    <thead class="bg-hover text-secondary">
                        <tr>
                            <th class="px-6 py-4 font-semibold">IoT Serial Number</th>
                            <th class="px-6 py-4 font-semibold">Device Type</th>
                            <th class="px-6 py-4 font-semibold">SIM Status</th>
                            <th class="px-6 py-4 font-semibold">Service Provider</th>
                            <th class="px-6 py-4 font-semibold">SIM No</th>
                        </tr>
                    </thead>

                    <!-- BODY -->
                    <tbody>
                        <tr
                            *ngFor="let item of inventoryList"
                            class="border-b border-divider hover:bg-hover transition"
                        >
                            <td class="px-6 py-4 font-medium text-primary">
                                {{ item.ChipID }}
                            </td>

                            <td class="px-6 py-4">
                                {{
                                    item.device_type
                                        ? item.device_type === 'C1'
                                            ? 'Critical'
                                            : 'Non-critical'
                                        : '-'
                                }}
                            </td>

                            <td class="px-6 py-4">
                                <span
                                    class="inline-flex items-center rounded-full px-3 py-1 text-xs font-medium"
                                    [ngClass]="{
                                      'bg-green-500/15 text-green-400': item.sim_status === 'With SIM',
                                      'bg-slate-500/20 text-secondary': item.sim_status === 'Without SIM'
                                    }"
                                >
                                    {{ item.sim_status }}
                                </span>
                            </td>

                            <td class="px-6 py-4">
                                {{ item.sim_operator || '-' }}
                            </td>

                            <td class="px-6 py-4">
                                {{ item.sim_serial_number || '-' }}
                            </td>
                        </tr>

                        <!-- EMPTY -->
                        <tr *ngIf="!inventoryList.length">
                            <td colspan="5" class="py-10 text-center text-hint">
                                No inventory records found
                            </td>
                        </tr>
                    </tbody>

                </table>
            </div>
        </div>
    </div>

    <!-- ================= REGISTER DEVICE MODAL ================= -->
    <div
        *ngIf="showDialog"
        class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/70"
    >
        <div
            class="w-full max-w-md rounded-2xl bg-card
                   border border-divider shadow-xl p-6"
        >

            <!-- MODAL HEADER -->
            <div class="flex items-center justify-between mb-6">
                <h3 class="text-lg font-semibold">
                    Register Device
                </h3>
                <button mat-icon-button (click)="closeDialog()">
                    <mat-icon>close</mat-icon>
                </button>
            </div>

            <!-- FORM -->
            <form [formGroup]="deviceForm" class="space-y-4">

                <!-- SERIAL -->
                <div>
                    <label class="text-secondary text-sm font-medium">
                        IoT Serial Number
                    </label>
                    <input
                        type="text"
                        formControlName="serial_number"
                        class="mt-1 w-full rounded-lg border border-divider
                               bg-transparent px-3 py-2
                               focus:outline-none focus:ring-2 focus:ring-primary"
                    />
                    <mat-error
                        *ngIf="deviceForm.get('serial_number')?.touched && deviceForm.get('serial_number')?.hasError('required')"
                    >
                        Serial Number is required
                    </mat-error>
                </div>

                <!-- DEVICE TYPE -->
                <div>
                    <label class="text-secondary text-sm font-medium">
                        Device Type
                    </label>
                    <select
                        formControlName="device_type"
                        class="mt-1 w-full rounded-lg border border-divider
                               bg-transparent px-3 py-2
                               focus:outline-none focus:ring-2 focus:ring-primary"
                    >
                        <option value="">Select</option>
                        <option *ngFor="let type of deviceTypes" [value]="type">
                            {{ deviceTypeLabels[type] }}
                        </option>
                    </select>
                </div>

                <!-- SIM STATUS -->
                <div>
                    <label class="text-secondary text-sm font-medium">
                        SIM Status
                    </label>
                    <select
                        formControlName="sim_status"
                        class="mt-1 w-full rounded-lg border border-divider
                               bg-transparent px-3 py-2
                               focus:outline-none focus:ring-2 focus:ring-primary"
                    >
                        <option value="">Select</option>
                        <option *ngFor="let status of simStatusList" [value]="status">
                            {{ status }}
                        </option>
                    </select>
                </div>

                <!-- CONDITIONAL -->
                <ng-container *ngIf="deviceForm.get('sim_status')?.value === 'With SIM'">

                    <div>
                        <label class="text-secondary text-sm font-medium">
                            Service Provider
                        </label>
                        <select
                            formControlName="sim_operator"
                            class="mt-1 w-full rounded-lg border border-divider
                                   bg-transparent px-3 py-2
                                   focus:outline-none focus:ring-2 focus:ring-primary"
                        >
                            <option value="">Select</option>
                            <option *ngFor="let op of simOperators" [value]="op">
                                {{ op }}
                            </option>
                        </select>
                    </div>

                    <div>
                        <label class="text-secondary text-sm font-medium">
                            SIM Number
                        </label>
                        <input
                            type="text"
                            maxlength="15"
                            formControlName="sim_serial_number"
                            class="mt-1 w-full rounded-lg border border-divider
                                   bg-transparent px-3 py-2
                                   focus:outline-none focus:ring-2 focus:ring-primary"
                        />
                    </div>

                </ng-container>

                <!-- ACTIONS -->
                <div class="flex justify-end gap-3 pt-6">
                    <button
                        type="button"
                        (click)="closeDialog()"
                        class="rounded-lg border border-divider px-4 py-2 text-secondary hover:bg-hover"
                    >
                        Cancel
                    </button>

                    <button
                        type="button"
                        (click)="submitDevice()"
                        class="rounded-lg bg-primary px-4 py-2 font-semibold text-white hover:bg-primary-700"
                    >
                        Submit
                    </button>
                </div>

            </form>
        </div>
    </div>

</div>
